<template>
  <div class="activitySwiper">
    <swiper ref="activitySwiper" :options="options">
      <swiper-slide
        v-for="(item, index) in activityImgs"
        v-bind:key="'activity-slide' + index"
        class="activity-slide cursor-pointer"
        @click.native.stop="goActivityDetail(item.id)"
      >
        <div>
          <img :src="item.img" />
        </div>
      </swiper-slide>

      <!-- <div class="swiper-pagination" slot="pagination"></div> -->
    </swiper>
    <div class="swiper-button-prev-custom-activity" v-if="activityImgs?.length > 1">
      <i class="el-icon-arrow-left"></i>
    </div>
    <div class="swiper-button-next-custom-activity" v-if="activityImgs?.length > 1">
      <i class="el-icon-arrow-right"></i>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
export default {
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    activityId: {
      type: Number,
    },
    activityImgs: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    options() {
      console.log('this?.activityImgs: ', this?.activityImgs);

      return {
        loop: this?.activityImgs?.length > 1 ? true : false,
        autoplay: this?.activityImgs?.length > 1 ? true : false,
        navigation: {
          nextEl: '.activitySwiper .swiper-button-next-custom-activity',
          prevEl: '.activitySwiper .swiper-button-prev-custom-activity',
        },
      };
    },
  },

  data() {
    return {};
  },

  methods: {
    // 跳转到活动详情
    goActivityDetail(activityId) {
      this.$emit('goActivityDetail', activityId);
    },
  },
};
</script>

<style lang="scss" scoped>
.activitySwiper {
  position: relative;
  .swiper-container {
    .activity-slide {
      img {
        display: block;
        max-width: 100%;
        width: 100%;
      }
    }

    .cursor-pointer {
      cursor: pointer;
    }

    ::v-deep .swiper-pagination {
      .swiper-pagination-bullet {
        background: #fff;
        border-radius: 4px;
        transition: all 0.5s;
      }

      .swiper-pagination-bullet-active {
        width: 30px;
        background: $main-color;
      }
    }
  }

  .swiper-button-prev-custom-activity,
  .swiper-button-next-custom-activity {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    border-radius: 100%;
    background: rgba(0, 0, 0, 0.2);
    position: absolute;
    top: calc(50% - 12px);
    z-index: 1;
    cursor: pointer;
    color: #fff;
  }

  .swiper-button-prev-custom-activity {
    left: 4px;
  }

  .swiper-button-next-custom-activity {
    right: 4px;
  }
}
</style>
